import apiFetch from '../apiFetch'

export default function (token, id) {
  return apiFetch({ endPoint: `SaleType/CanDelete/${id}`, method: 'GET', body: null, token: token })
}
